import BaseService from "./BaseService";

const BASE = "audit-logs";

// The query string of the filters that are set (undefined, null and "" are left out).
const query = (params = {}) =>
  new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  ).toString();

export const getAuditLogs = (params) => BaseService.callAPI(`${BASE}?${query(params)}`);

export const getAuditLog = (id) => BaseService.callAPI(`${BASE}/${id}`);

export const getAuditLogOptions = () => BaseService.callAPI(`${BASE}/options`);

// The Anyone filter's people (name, email or username matches; the first 50 without a search).
export const getAuditLogPeople = (search) =>
  BaseService.callAPI(search ? `${BASE}/people?${query({ search })}` : `${BASE}/people`);

// fileType "excel" or "csv"; the same filters as the list, plus the browser's
// time zone (timezone) for the times in the file.
export const exportAuditLogs = (fileType, params) =>
  BaseService.callAPI(`${BASE}/export/${fileType}?${query(params)}`, "POST", {}, { responseType: "blob" });
